import React, { useState } from "react";
import { Modal, Accordion, Form, Button, InputGroup } from "react-bootstrap";

const FAQModal = ({ show, onHide, faqs }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [chatMessages, setChatMessages] = useState([]);
    const [chatInput, setChatInput] = useState("");

    const filteredFAQs = searchTerm
        ? faqs.filter(faq =>
            faq.question.toLowerCase().includes(searchTerm.toLowerCase()) || faq.answer.toLowerCase().includes(searchTerm.toLowerCase())
        )
        : faqs.slice(0, 3);

    const handleChatSubmit = async (e) => {
        e.preventDefault();
        if (chatInput.trim()) {
            setChatMessages([...chatMessages, { sender: "user", text: chatInput }]);

            try{
                const response = await fetch("http://127.0.0.1:5000/ask", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ "question": chatInput }),
                });

                const data = await response.json();

                setChatMessages((prevMessages) => [
                    ...prevMessages,
                    { sender: "bot", text: data.answer || "No response from the server." },
                ]);
            } catch (error) {
                setChatMessages((prevMessages) => [
                    ...prevMessages,
                    { sender: "bot", text: "An error occurred while fetching the response." },
                ]);
            }

            setChatInput("");
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Frequently Asked Questions & Chat</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex">
                    {/* FAQ Section */}
                    <div className="faq-section me-3" style={{ flex: 1 }}>
                        <Form.Control
                            type="text"
                            placeholder="Search FAQs..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="mb-3"
                        />
                        <Accordion>
                            {filteredFAQs.map((faq, index) => (
                                <Accordion.Item eventKey={index.toString()} key={index}>
                                    <Accordion.Header>{faq.question}</Accordion.Header>
                                    <Accordion.Body>{faq.answer}</Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </div>

                    {/* Chatbot Section */}
                    <div className="chatbot-section" style={{ flex: 1, borderLeft: "1px solid #ddd", paddingLeft: "1rem" }}>
                        <div className="chat-window" style={{ height: "300px", overflowY: "auto", marginBottom: "1rem", border: "1px solid #ddd", borderRadius: "5px", padding: "0.5rem" }}>
                            {chatMessages.map((message, index) => (
                                <div
                                    key={index}
                                    style={{
                                        textAlign: message.sender === "user" ? "right" : "left",
                                        marginBottom: "0.5rem",
                                    }}
                                >
                  <span
                      style={{
                          display: "inline-block",
                          padding: "0.5rem",
                          borderRadius: "10px",
                          backgroundColor: message.sender === "user" ? "#007bff" : "#f1f1f1",
                          color: message.sender === "user" ? "#fff" : "#000",
                      }}
                  >
                    {message.text}
                  </span>
                                </div>
                            ))}
                        </div>
                        <Form onSubmit={handleChatSubmit}>
                            <InputGroup>
                                <Form.Control
                                    type="text"
                                    placeholder="Type your message..."
                                    value={chatInput}
                                    onChange={(e) => setChatInput(e.target.value)}
                                />
                                <Button type="submit" variant="primary">
                                    Send
                                </Button>
                            </InputGroup>
                        </Form>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default FAQModal;
